// MUST be first import - runs before Supabase client initializes
// This intercepts recovery URLs and sets a flag before Supabase processes them
import '@/lib/auth-recovery-interceptor';
import { supabase } from '@/lib/supabase-client-wrapper';
import { initSentry } from '@/lib/sentry';

// Sentry before React (same idea as Sentry quickstart); config lives in @/lib/sentry (DSN, sendDefaultPii, integrations).
initSentry(supabase);

import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/website-redesign.css'
import { removeLovableBadge, watchForLovableBadge } from '@/lib/removeLovableBadge'

removeLovableBadge();
watchForLovableBadge();

createRoot(document.getElementById('root')!).render(<App />);
